import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";

interface SearchParticipantsProps {
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchParticipants = ({
  onSearchChange,
}: SearchParticipantsProps) => (
  <div className="grow">
    <Icon type="search" />
    <input
      type="text"
      name="textSearch"
      placeholder={t("live_streams.dashboard.participants.placeholder")}
      onChange={onSearchChange}
      className="bg-primary placeholder:text-light mr-2 w-10/12 border-transparent placeholder:opacity-100 focus:border-transparent focus:ring-0"
    />
  </div>
);
